import { render } from "./SalesReview.vue?vue&type=template&id=73380f9e"
import script from "./SalesReview.vue?vue&type=script&lang=js"
export * from "./SalesReview.vue?vue&type=script&lang=js"

import "./SalesReview.vue?vue&type=style&index=0&id=73380f9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__